import Button from '@mui/material/Button';
import './LinkButton.css';

const LinkButton = () => {
    return (
        <div id='buttonDiv'>
            <Button className="inviteButton" variant="outlined" size="large"
                    onClick={() => window.open('https://discord.com/oauth2/authorize?client_id=930889069158858772&permissions=2048&scope=bot', '_blank')}>Invite
                Bot</Button>
        </div>
    );
};
export default LinkButton;